import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ImportItemResult } from '@/model/importer';
import type { ArcualInventoryItem } from '@arcual/lib-app-platform';

export const BulkUploadStoreName = 'BulkUploadStore';
export const useBulkUploadStore = defineStore(
  BulkUploadStoreName,
  () => {
    const importResult = ref<ImportItemResult<ArcualInventoryItem> | null>(null);

    const setImportResult = (newImportResult: ImportItemResult<ArcualInventoryItem>) => {
      importResult.value = newImportResult;
    };

    const clearImportResult = () => {
      importResult.value = null;
    };

    /**
     * Reset the store to its initial state
     */
    const reset = () => {
      clearImportResult();
    };

    return {
      setImportResult,
      clearImportResult,
      importResult,
      reset,
    };
  },
  { persist: { paths: ['importResult'] } },
);
